import type { ClFarmRepository } from "@/domains/cl-farm/cl-farm-repository"
import { LcAddress } from "@/domains/core"

import type { IGaugeConnectorStrategy, IRevenueSource } from "../interfaces"
import { REVENUE_SOURCE_TYPE } from "../interfaces"

export class ClFarmGaugeConnectorStrategy implements IGaugeConnectorStrategy {
  readonly revenueSourceType = REVENUE_SOURCE_TYPE.CL_FARM

  constructor(private readonly clFarmRepository: ClFarmRepository) {}

  findRevenueSourceByGauge(gauge: LcAddress): IRevenueSource | undefined {
    const farm = this.clFarmRepository.findByGauge(gauge)

    // Only log if not found - success is silent
    if (!farm) {
      // Don't log here - let the caller (gauge orchestrator) log if no revenue source found at all
      return undefined
    }

    // Return the farm directly - ClFarmStore implements IRevenueSource
    // This maintains MobX reactivity since the gauge will observe the actual store instance
    return farm
  }
}
